import { MultiTierTax } from './../../classes/multiTierTax/multiTierTax';
import { rates } from './config';
import { MkbWinstVrijstellingConfig } from './interface';

export class MkbWinstVrijstelling {
    
    tax: number;
    
    constructor(data: MkbWinstVrijstellingConfig) {
        this.tax = new MultiTierTax(rates[data.year], data.profit).tax;
    }
    
}
